import React, { useContext, useEffect, useMemo, useState } from 'react';
import { IonAccordion, IonAccordionGroup, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonChip, IonContent, IonFab, IonFabButton, IonFabList, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonModal, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { DataContext } from '../context/DataContext';
import Archiv from '../components/Archiv';
import Auswahl from '../components/Auswahl';
import { add, cash, cashOutline, cogOutline, logOutOutline, paperPlaneOutline, peopleCircleOutline, person, personCircleOutline, warning } from 'ionicons/icons';
import Toolbar from '../components/Toolbar';
import Settings from './Settings';

const LEERE_BESTELLUNGEN: Record<string, any> = {};

const Home: React.FC = () => {
  const history = useHistory();
  const { 
    appLoggedIn, 
    appLoggedInChange,
    appUserData,
    appUserDataChange,
    appToken,
    appReloadSpeiseplanChange,
    appUserSpeiseplan,
    appUserVerzehr,
    appWarenkorb,
    appWarenkorbChange,
    appWarenkorbResetSignal,
    appSelectedSchuelerId,
    appSelectedSchuelerIdChange,

  } = useContext(DataContext);

  const schuelerListe = Array.isArray(appUserData?.schueler) ? appUserData.schueler : [];

  const getSchuleLabel = (schueler: any) => {
    const rawSchule = String(
      schueler?.campusmenu_schueler_schule_name ??
      schueler?.schuelerdaten?.campusmenu_schueler_schule_name ??
      schueler?.campusmenu_schueler_schule ??
      schueler?.schuelerdaten?.campusmenu_schueler_schule ??
      schueler?.campusmenu_schueler_schule_id ??
      schueler?.schuelerdaten?.campusmenu_schueler_schule_id ??
      ''
    ).trim();

    if (!rawSchule) {
      return '';
    }

    if (rawSchule === '5') {
      return 'SEE-FAB - GS Seebek Fab';
    }

    if (rawSchule === '130') {
      return 'GySue - Gymnasium Süderelbe';
    }

    return rawSchule;
  };

  const getSchuelerLabel = (schueler: any) => {
    if (!schueler || typeof schueler !== 'object') {
      return '';
    }

    const campusmenu_schueler_id = String(schueler.campusmenu_schueler_id || '').padStart(6, '0');
    const nachname = schueler.campusmenu_schueler_nachname || schueler?.schuelerdaten?.campusmenu_schueler_nachname || '';
    const vorname = schueler.campusmenu_schueler_vorname || schueler?.schuelerdaten?.campusmenu_schueler_vorname || '';
    const klasse = schueler.campusmenu_schueler_klasse || schueler?.schuelerdaten?.campusmenu_schueler_klasse || '';
    const schule = getSchuleLabel(schueler);

    const name = [nachname, vorname].filter(Boolean).join(', ');
    const klasseSchule = [klasse, schule].filter(Boolean).join(' ');

    if (name && klasseSchule) {
      return `S${campusmenu_schueler_id} - ${name} (${klasseSchule})`;
    }

    return name || klasseSchule || 'Schueler';
  };

  const formatCampusmenuId = (id: any) => String(id ?? '').padStart(6, '0');

  const parsePreisProzent = (preisWert: any) => {
    if (typeof preisWert === 'number' && !Number.isNaN(preisWert)) {
      return preisWert;
    }

    if (typeof preisWert === 'string') {
      const normalisiert = preisWert.replace('%', '').replace(',', '.').trim();
      const parsed = Number.parseFloat(normalisiert);

      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    return 100;
  };

  const parseVerzehr = (verzehrWert: any) => {
    if (!verzehrWert) {
      return {};
    }

    if (typeof verzehrWert === 'object') {
      return verzehrWert;
    }

    if (typeof verzehrWert === 'string') {
      try {
        return JSON.parse(verzehrWert);
      } catch {
        return {};
      }
    }

    return {};
  };

  const [ localAuswahl, setLocalAuswahl ]: any = useState( [] );
  const [ localArchiv, setLocalArchiv ] = useState( null );
  const [ localVerzehr, setLocalVerzehr ] = useState( null );
  const [ localWarenkorbFab, setLocalWarenkorbFab ]:any = useState( null );
  const selectedSchuelerId = appSelectedSchuelerId;
  const setSelectedSchuelerId = appSelectedSchuelerIdChange;
  const [ neueBestellungenProSchueler, setNeueBestellungenProSchueler ] = useState<Record<string, Record<string, any>>>({});
  const [ isBestellenLoading, setIsBestellenLoading ] = useState(false);
  const [ isWarenkorbModalOpen, setIsWarenkorbModalOpen ] = useState(false);
  const [ isKontoModalOpen, setIsKontoModalOpen ] = useState(false);
  const [ lastschriftEinzug, setLastschriftEinzug ] = useState(true);
  const [ isKundenkontoModalOpen, setIsKundenkontoModalOpen ] = useState(false);
  const [ isSchuelerkontoModalOpen, setIsSchuelerkontoModalOpen ] = useState(false);
  const [ isHinweisModalOpen, setIsHinweisModalOpen ] = useState(false);
  const [ schuelerWechselZiel, setSchuelerWechselZiel ] = useState<string | null>(null);

  const selectedSchuelerKey = selectedSchuelerId !== null && selectedSchuelerId !== undefined
    ? String(selectedSchuelerId)
    : '';
  const neueBestellungen = useMemo(
    () => (selectedSchuelerKey ? (neueBestellungenProSchueler[selectedSchuelerKey] || LEERE_BESTELLUNGEN) : LEERE_BESTELLUNGEN),
    [selectedSchuelerKey, neueBestellungenProSchueler]
  );

  const requestSchuelerWechsel = (zielSchuelerId: any) => {
    if (!setSelectedSchuelerId) {
      return;
    }

    const ziel = zielSchuelerId !== null && zielSchuelerId !== undefined ? String(zielSchuelerId) : null;
    const aktuell = selectedSchuelerId !== null && selectedSchuelerId !== undefined ? String(selectedSchuelerId) : null;

    if (ziel === aktuell) {
      return;
    }

    const offeneAenderungen = aktuell ? Object.keys(neueBestellungenProSchueler[aktuell] || {}).length > 0 : false;
    if (offeneAenderungen) {
      setSchuelerWechselZiel(ziel);
      setIsHinweisModalOpen(true);
      return;
    }

    setSelectedSchuelerId(ziel);
  };

  const bestaetigeSchuelerWechsel = () => {
    const aktuell = selectedSchuelerId !== null && selectedSchuelerId !== undefined ? String(selectedSchuelerId) : null;

    if (aktuell) {
      setNeueBestellungenProSchueler((prev) => {
        const next = { ...prev };
        delete next[aktuell];
        return next;
      });
    }

    if (setSelectedSchuelerId) {
      setSelectedSchuelerId(schuelerWechselZiel);
    }

    setIsHinweisModalOpen(false);
    setSchuelerWechselZiel(null);
  };

  const abbrechenSchuelerWechsel = () => {
    setIsHinweisModalOpen(false);
    setSchuelerWechselZiel(null);
  };

  useEffect(() => {
    if (!setSelectedSchuelerId) {
      return;
    }

    if (schuelerListe.length === 0) {
      if (selectedSchuelerId !== null) {
        setSelectedSchuelerId(null);
      }
      return;
    }

    const istGueltigeAuswahl = schuelerListe.some(
      (schueler: any, index: number) =>
        String(schueler.campusmenu_schueler_id || index) === String(selectedSchuelerId)
    );

    if (!istGueltigeAuswahl) {
      const fallbackSchuelerId = String(schuelerListe[0].campusmenu_schueler_id || 0);
      setSelectedSchuelerId(fallbackSchuelerId);
    }
  }, [schuelerListe, selectedSchuelerId, setSelectedSchuelerId]);

  const selectedSchueler = schuelerListe.find(
    (schueler: any, index: number) => String(schueler.campusmenu_schueler_id || index) === String(selectedSchuelerId)
  );
  const selectedSchuelerSchoolId = String(
    selectedSchueler?.campusmenu_schueler_schule_id ??
    selectedSchueler?.schuelerdaten?.campusmenu_schueler_schule_id ??
    selectedSchueler?.campusmenu_schueler_schule ??
    selectedSchueler?.schuelerdaten?.campusmenu_schueler_schule ??
    ''
  ).trim();
  const isSchool130 = selectedSchuelerSchoolId === '130';
  const selectedSchuelerPreisProzent = parsePreisProzent(selectedSchueler?.campusmenu_schueler_preis);
  const neueBestellungenListe = Object.values(neueBestellungen)
    .flatMap((eintrag: any) => {
      const bestellungen: any[] = [];

      if (eintrag?.stornierung) {
        bestellungen.push({
          datum: eintrag.datum,
          ...eintrag.stornierung,
        });
      }

      if (eintrag?.kategorie !== undefined && eintrag?.kategorie !== null && Number(eintrag?.menge ?? 0) > 0) {
        bestellungen.push(eintrag);
      }

      return bestellungen;
    })
    .sort((a: any, b: any) => a.datum.localeCompare(b.datum));
  const neueBestellungenSumme = neueBestellungenListe.reduce((summe: number, eintrag: any) => {
    const preis = Number(eintrag.preis || 0);
    const menge = Number(eintrag.menge ?? 1);
    return summe + preis * menge;
  }, 0);
  const waehrungFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  const getKontowertAnzeige = (wert: any) => Number(wert || 0) * -1;
  const formatMengeMalWert = (menge: any, wert: any) => {
    const mengeNummer = Number(menge || 0);
    return `${mengeNummer} x ${waehrungFormatter.format(getKontowertAnzeige(wert))}`;
  };
  const geparsteVerzehrEintraege = (() => {
    try {
      const parsed = typeof appWarenkorb === 'string' ? JSON.parse(appWarenkorb) : appWarenkorb;

      if (Array.isArray(parsed)) {
        return parsed;
      }

      if (parsed && typeof parsed === 'object') {
        if (Array.isArray((parsed as any).data)) {
          return (parsed as any).data;
        }

        if (Array.isArray((parsed as any).verzehr)) {
          return (parsed as any).verzehr;
        }

        if (Array.isArray((parsed as any).items)) {
          return (parsed as any).items;
        }

        const ersteArrayEigenschaft = Object.values(parsed).find((wert) => Array.isArray(wert));
        if (Array.isArray(ersteArrayEigenschaft)) {
          return ersteArrayEigenschaft;
        }
      }

      return [];
    } catch {
      return [];
    }
  })();
  const leseVerzehrFeld = (eintrag: any, keys: string[]) => {
    for (const key of keys) {
      const value = eintrag?.[key];
      if (value !== undefined && value !== null) {
        return value;
      }
    }

    return '';
  };
  const parseVerzehrBetrag = (wert: any) => {
    if (typeof wert === 'number' && !Number.isNaN(wert)) {
      return wert;
    }

    if (typeof wert === 'string') {
      const normalisiert = wert.replace(',', '.').replace(/[^0-9.-]/g, '').trim();
      const parsed = Number.parseFloat(normalisiert);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    return 0;
  };
  const getKategorie = (eintrag: any) => String(leseVerzehrFeld(eintrag, ['saint_campusmenu_kategorie', 'campusmenu_kategorie'])).toUpperCase();
  const getMenueTitel = (kategorie: string) => {
    if (kategorie === '1') {
      return 'Vielfalt und Bunt';
    }

    if (kategorie === '2') {
      return 'Vegi und Genuss';
    }

    return '';
  };
  const menuKategorien = new Set(['1', '2']);
  const zahlungsKategorien = new Set(['L', 'U']);
  const sonderbuchungKategorien = new Set(['999', '998', '997', '996']);
  const getSonderbuchungTitel = (kategorie: string) => {
    if (kategorie === '999') {
      return 'Lastschrifteinzug';
    }

    if (kategorie === '998') {
      return 'Automatische Lastschrift';
    }

    if (kategorie === '997') {
      return 'Überweisung';
    }

    if (kategorie === '996') {
      return 'Buchung Servicecenter';
    }

    return 'Sonderbuchung';
  };
  const parseDateOnly = (datumText: string) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(datumText)) {
      return null;
    }
    const [jahr, monat, tag] = datumText.split('-').map(Number);
    return new Date(jahr, monat - 1, tag);
  };
  const heute = new Date();
  const heuteNurDatum = new Date(heute.getFullYear(), heute.getMonth(), heute.getDate());
  const maxZukunftsDatum = new Date(heuteNurDatum);
  maxZukunftsDatum.setDate(maxZukunftsDatum.getDate() + 30);
  const bestehendeMenueEintraege = geparsteVerzehrEintraege.filter((eintrag: any) => {
    const kategorie = getKategorie(eintrag);
    return menuKategorien.has(kategorie);
  });
  const serverStatusNachDatum = (() => {
    const menuKategorienSet = new Set(['1', '2']);
    const events = geparsteVerzehrEintraege
      .map((eintrag: any) => ({
        datum: String(leseVerzehrFeld(eintrag, ['saint_campusmenu_datum', 'campusmenu_datum'])).slice(0, 10),
        kategorie: getKategorie(eintrag),
        menge: Number(leseVerzehrFeld(eintrag, ['saint_campusmenu_verzehr_menge', 'campusmenu_verzehr_menge', 'gaeste_verzehr_menge']) || 0),
        verzehrId: Number(leseVerzehrFeld(eintrag, ['saint_campusmenu_verzehr_id', 'campusmenu_verzehr_id', 'gaeste_verzehr_id']) || 0),
      }))
      .filter((eintrag: any) => {
        if (!eintrag.datum || Number.isNaN(eintrag.verzehrId) || eintrag.verzehrId <= 0) {
          return false;
        }

        return eintrag.kategorie === '0' || menuKategorienSet.has(eintrag.kategorie);
      })
      .sort((a: any, b: any) => {
        if (a.datum !== b.datum) {
          return String(a.datum).localeCompare(String(b.datum));
        }

        return Number(a.verzehrId) - Number(b.verzehrId);
      });

    const standNachDatum: Record<string, {
      qty1: number;
      qty2: number;
      lastId1: number;
      lastId2: number;
    }> = {};

    for (const event of events) {
      const stand = standNachDatum[event.datum] || {
        qty1: 0,
        qty2: 0,
        lastId1: 0,
        lastId2: 0,
      };

      if (event.kategorie === '0') {
        stand.qty1 = 0;
        stand.qty2 = 0;
        stand.lastId1 = 0;
        stand.lastId2 = 0;
      } else if (event.kategorie === '1') {
        stand.qty1 += Number(event.menge || 0);
        stand.lastId1 = Number(event.verzehrId || 0);
      } else if (event.kategorie === '2') {
        stand.qty2 += Number(event.menge || 0);
        stand.lastId2 = Number(event.verzehrId || 0);
      }

      standNachDatum[event.datum] = stand;
    }

    const result: Record<string, { kategorie: number | null; menge: number }> = {};
    Object.entries(standNachDatum).forEach(([datum, stand]) => {
      const qty1 = Math.max(0, Math.round(stand.qty1));
      const qty2 = Math.max(0, Math.round(stand.qty2));

      if (qty1 <= 0 && qty2 <= 0) {
        result[datum] = { kategorie: null, menge: 0 };
        return;
      }

      if (qty1 > 0 && qty2 <= 0) {
        result[datum] = { kategorie: 1, menge: qty1 };
        return;
      }

      if (qty2 > 0 && qty1 <= 0) {
        result[datum] = { kategorie: 2, menge: qty2 };
        return;
      }

      // Sollte fachlich nicht vorkommen (pro Tag ein Menü), wir nehmen den zuletzt geänderten Stand.
      if (stand.lastId2 >= stand.lastId1) {
        result[datum] = { kategorie: 2, menge: qty2 };
      } else {
        result[datum] = { kategorie: 1, menge: qty1 };
      }
    });

    return result;
  })();
  const serverKategorieNachDatum = Object.fromEntries(
    Object.entries(serverStatusNachDatum).map(([datum, stand]) => [datum, stand.kategorie])
  ) as Record<string, number | null>;
  const serverMengeNachDatum = Object.fromEntries(
    Object.entries(serverStatusNachDatum).map(([datum, stand]) => [datum, stand.menge])
  ) as Record<string, number>;
  const hatWarenkorbEintrag = bestehendeMenueEintraege.length > 0;
  const kontoBewegungen = geparsteVerzehrEintraege
    .map((eintrag: any) => {
      const kategorie = getKategorie(eintrag);
      const wert = parseVerzehrBetrag(leseVerzehrFeld(eintrag, ['saint_campusmenu_wert', 'campusmenu_wert']));
      const datumRaw = String(leseVerzehrFeld(eintrag, ['saint_campusmenu_datum', 'campusmenu_datum'])).slice(0, 10);
      const wertstellung = String(leseVerzehrFeld(eintrag, ['saint_campusmenu_wertstellung', 'campusmenu_wertstellung']));
      const datum = datumRaw;
      const notiz = String(leseVerzehrFeld(eintrag, ['saint_campusmenu_anmerkung', 'campusmenu_anmerkung'])).trim();
      const verzehrId = Number(leseVerzehrFeld(eintrag, ['saint_campusmenu_verzehr_id', 'campusmenu_verzehr_id', 'gaeste_verzehr_id']) || 0);
      const menge = Number(leseVerzehrFeld(eintrag, ['saint_campusmenu_verzehr_menge', 'campusmenu_verzehr_menge', 'gaeste_verzehr_menge']) || 0);

      const menueTitel = getMenueTitel(kategorie);
      let text = menueTitel ? menueTitel : `Kategorie ${kategorie || '-'}`;
      if (notiz) {
        text = `${text} - ${notiz}`;
      }

      const datumObj = /^\d{4}-\d{2}-\d{2}$/.test(datum)
        ? new Date(`${datum}T00:00:00`)
        : null;
      const datumAnzeige = datumObj && !Number.isNaN(datumObj.getTime())
        ? datumObj.toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' })
        : datum;
      const gesamtpreis = wert * menge * -1;

      return {
        id: String(verzehrId || `${datum}_${kategorie}_${wert}`),
        verzehrId,
        campusmenuDatum: datumRaw,
        datum,
        datumAnzeige,
        kategorie,
        menge,
        einzelpreis: wert,
        gesamtpreis,
        wertstellung,
        anmerkung: notiz,
        text,
      };
    })
    .sort((a: any, b: any) => {
      const datumA = String(a.campusmenuDatum || '');
      const datumB = String(b.campusmenuDatum || '');

      if (datumA && datumB) {
        const datumSort = datumA.localeCompare(datumB);
        if (datumSort !== 0) {
          return datumSort;
        }
      }

      return Number(a.verzehrId || 0) - Number(b.verzehrId || 0);
    });
  const kontoSonderbuchungen = kontoBewegungen.filter((b: any) => sonderbuchungKategorien.has(String(b.kategorie)));
  const kontoTagesgruppen = kontoBewegungen.filter((b: any) => !sonderbuchungKategorien.has(String(b.kategorie))).reduce((acc: any[], bewegung: any) => {
    const bestehend = acc.find((gruppe: any) => gruppe.datum === bewegung.datum);

    if (!bestehend) {
      acc.push({
        datum: bewegung.datum,
        datumAnzeige: bewegung.datumAnzeige,
        gesamtMenge: Number(bewegung.menge || 0),
        gesamtPreis: Number(bewegung.gesamtpreis || 0),
        bewegungen: [bewegung],
      });
      return acc;
    }

    bestehend.gesamtMenge += Number(bewegung.menge || 0);
    bestehend.gesamtPreis += Number(bewegung.gesamtpreis || 0);
    bestehend.bewegungen.push(bewegung);
    return acc;
  }, []).sort((a: any, b: any) => String(a.datum).localeCompare(String(b.datum)));
  const kontoEndsaldo = kontoBewegungen.reduce((summe: number, eintrag: any) => summe + Number(eintrag.gesamtpreis || 0), 0);
  const kontoZwischenstand30Tage = kontoBewegungen
    .filter((eintrag: any) => {
      const datumObj = parseDateOnly(String(eintrag.datum || ''));
      if (!datumObj) {
        return false;
      }

      return datumObj <= maxZukunftsDatum;
    })
    .reduce((summe: number, eintrag: any) => summe + Number(eintrag.gesamtpreis || 0), 0);
  const zwischenstandStichtagAnzeige = maxZukunftsDatum.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const zwischenstandStichtagIso = `${maxZukunftsDatum.getFullYear()}-${String(maxZukunftsDatum.getMonth() + 1).padStart(2, '0')}-${String(maxZukunftsDatum.getDate()).padStart(2, '0')}`;
  const kontoZeilenGesamt: any[] = [
    ...kontoTagesgruppen.map((g: any) => ({ type: 'gruppe', ...g })),
    ...kontoSonderbuchungen.map((e: any) => ({ type: 'sonderbuchung', ...e })),
  ].sort((a: any, b: any) => String(a.datum).localeCompare(String(b.datum)));
  const zwischenstandInsertIndex = (() => {
    const index = kontoZeilenGesamt.findIndex((zeile: any) => String(zeile.datum || '') > zwischenstandStichtagIso);
    return index === -1 ? kontoZeilenGesamt.length : index;
  })();
  const kontoZeilenBisZwischenstand = kontoZeilenGesamt.slice(0, zwischenstandInsertIndex);
  const kontoZeilenNachZwischenstand = kontoZeilenGesamt.slice(zwischenstandInsertIndex);

  const upsertNeueBestellung = (datum: string, payload: any, serverKategorie: number | null, serverMenge?: number | null) => {
    setNeueBestellungenProSchueler((prev) => {
      if (!selectedSchuelerKey) {
        return prev;
      }

      const next = { ...prev };
      const aktuelleBestellungen = { ...(prev[selectedSchuelerKey] || {}) };
      const serverKategorieNummer = Number(serverKategorie ?? 0);
      const serverMengeGanzzahl = Math.max(0, Math.round(Math.abs(Number(serverMenge ?? 0))));
      const hatServerKategorie = Number.isFinite(serverKategorieNummer) && serverKategorieNummer > 0 && serverMengeGanzzahl > 0;
      const bisher = aktuelleBestellungen[datum] as any;
      const bisherGewuenschteKategorie =
        bisher && (bisher.menge ?? 0) > 0
          ? Number(bisher.kategorie)
          : (bisher?.stornierung ? null : undefined);
      const serverAuswahl = hatServerKategorie ? serverKategorieNummer : null;

      let gewuenschteKategorie: number | null = serverAuswahl;
      if (bisherGewuenschteKategorie !== undefined) {
        gewuenschteKategorie = bisherGewuenschteKategorie;
      }

      if (!payload) {
        gewuenschteKategorie = null;
      } else {
        const payloadKategorie = Number(payload.kategorie);
        const payloadMenge = Math.round(Number(payload.menge ?? 1));

        if (payloadMenge < 0) {
          gewuenschteKategorie = null;
        } else if (Number.isFinite(payloadKategorie) && payloadKategorie > 0) {
          gewuenschteKategorie = payloadKategorie;
        }
      }

      if (gewuenschteKategorie === serverAuswahl) {
        delete aktuelleBestellungen[datum];
        if (Object.keys(aktuelleBestellungen).length === 0) {
          delete next[selectedSchuelerKey];
        } else {
          next[selectedSchuelerKey] = aktuelleBestellungen;
        }
        return next;
      }

      const hatGewuenschteKategorie = Number.isFinite(Number(gewuenschteKategorie)) && Number(gewuenschteKategorie) > 0;
      const stornierungsTitel = serverKategorieNummer === 1
        ? 'Vielfalt und Bunt'
        : serverKategorieNummer === 2
          ? 'Vegi und Genuss'
          : `Menü ${serverKategorieNummer}`;
      const neueKategorieNummer = Number(gewuenschteKategorie ?? 0);
      const neuerTitel = payload?.titel
        || (neueKategorieNummer === 1
          ? 'Vielfalt und Bunt'
          : neueKategorieNummer === 2
            ? 'Vegi und Genuss'
            : `Menü ${neueKategorieNummer}`);
      const neuerPreis = Number(payload?.preis ?? bisher?.preis ?? 0);

      aktuelleBestellungen[datum] = {
        datum,
        kategorie: hatGewuenschteKategorie ? neueKategorieNummer : serverKategorieNummer,
        titel: hatGewuenschteKategorie ? neuerTitel : stornierungsTitel,
        preis: neuerPreis,
        menge: hatGewuenschteKategorie ? 1 : -1,
        stornierung: hatServerKategorie
          ? {
            kategorie: serverKategorieNummer,
            titel: stornierungsTitel,
            preis: neuerPreis,
            menge: serverMengeGanzzahl * -1,
          }
          : null,
      };

      if (!hatServerKategorie && !hatGewuenschteKategorie) {
        delete aktuelleBestellungen[datum];
      }

      if (Object.keys(aktuelleBestellungen).length === 0) {
        delete next[selectedSchuelerKey];
      } else {
        next[selectedSchuelerKey] = aktuelleBestellungen;
      }

      return next;
    });
  };

  const fetchGaesteVerzehrFuerSchueler = async (schuelerId: any) => {
    if (!appToken || !schuelerId) {
      return null;
    }

    const parseJsonAntwort = async (response: Response) => {
      const raw = await response.text();
      if (!raw || !raw.trim()) {
        return null;
      }

      try {
        return JSON.parse(raw);
      } catch {
        throw new Error(`Ungültige Server-Antwort (${response.status}): ${raw.slice(0, 200)}`);
      }
    };

    const verzehrFormData = new FormData();
    verzehrFormData.append('appToken', appToken);
    verzehrFormData.append('campusmenu_schueler_id', String(schuelerId));

    const verzehrResponse = await fetch(
      'https://login.saint-online.de/funktionen/api2/campusmenu/getGaesteVerzehr.php',
      { method: 'POST', body: verzehrFormData }
    );
    const verzehrData = await parseJsonAntwort(verzehrResponse);

    if (!verzehrResponse.ok) {
      throw new Error(`Serverfehler bei getGaesteVerzehr (${verzehrResponse.status}).`);
    }

    if (!verzehrData) {
      throw new Error('Leere Server-Antwort bei getGaesteVerzehr.');
    }

    if (verzehrData.status != 200) {
      throw new Error(JSON.stringify(verzehrData.msg));
    }

    if (appWarenkorbChange) {
      appWarenkorbChange(JSON.stringify(verzehrData.data));
    }

    return verzehrData;
  };

  const zahlungspflichtigBestellen = async () => {
    if (!appToken) {
      alert('Bitte erneut anmelden. Kein gueltiger App-Token vorhanden.');
      return;
    }

    if (!selectedSchuelerId) {
      alert('Bitte zuerst einen Schüler auswählen.');
      return;
    }

    if (neueBestellungenListe.length === 0) {
      return;
    }

    setIsBestellenLoading(true);

    try {
      const parseJsonAntwort = async (response: Response) => {
        const raw = await response.text();
        if (!raw || !raw.trim()) {
          return null;
        }

        try {
          return JSON.parse(raw);
        } catch {
          throw new Error(`Ungültige Server-Antwort (${response.status}): ${raw.slice(0, 200)}`);
        }
      };

      const istLastschriftManuell = String(selectedSchueler?.campusmenu_schueler_zahlung) === '1';
      const lastschriftEintrag = istLastschriftManuell && lastschriftEinzug && neueBestellungenSumme > 0
        ? [{
            campusmenu_betriebe_id: 1,
            campusmenu_datum: new Date().toISOString().slice(0, 10),
            gaeste_verzehr_mahlzeit: 2,
            gaeste_verzehr_plan_id: 0,
            campusmenu_kategorie: 999,
            campusmenu_wert: Number(neueBestellungenSumme)*-1,
            campusmenu_verzehr_menge: 1,
            gaeste_verzehr_schueler_id: Number(selectedSchuelerId),
            campusmenu_schueler_id: Number(selectedSchuelerId),
          }]
        : [];

      const payload = {
        appToken,
        modus: 'batch',
        bestellungen: [
          ...neueBestellungenListe.map((bestellung: any) => ({
          campusmenu_betriebe_id: 1,
          campusmenu_datum: bestellung.datum,
          gaeste_verzehr_mahlzeit: 2,
          gaeste_verzehr_plan_id: 0,
          campusmenu_kategorie: Number(bestellung.kategorie),
          campusmenu_wert: Number(bestellung.preis),
          campusmenu_verzehr_menge: Number(bestellung.menge ?? 1),
          gaeste_verzehr_schueler_id: Number(selectedSchuelerId),
          campusmenu_schueler_id: Number(selectedSchuelerId),
        })),
          ...lastschriftEintrag,
        ],
      };

      const response = await fetch(
        'https://login.saint-online.de/funktionen/api2/campusmenu/setGaesteVerzehr.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await parseJsonAntwort(response);

      if (!response.ok) {
        throw new Error(`Serverfehler bei setGaesteVerzehr (${response.status}).`);
      }

      if (!data) {
        throw new Error('Leere Server-Antwort bei setGaesteVerzehr.');
      }

      if (data.status != 200) {
        throw new Error(JSON.stringify(data.msg));
      }

      await fetchGaesteVerzehrFuerSchueler(selectedSchuelerId);

      if (selectedSchuelerKey) {
        setNeueBestellungenProSchueler((prev) => {
          const next = { ...prev };
          delete next[selectedSchuelerKey];
          return next;
        });
      }
      appReloadSpeiseplanChange(Math.random());
      setIsWarenkorbModalOpen(false);
      alert('Bestellungen wurden zahlungspflichtig übertragen.');
    } catch (error: any) {
      alert(error?.message || 'Bestellungen konnten nicht übertragen werden.');
    } finally {
      setIsBestellenLoading(false);
    }
  };

  useEffect(() => {
    let istAktiv = true;

    if (!appToken || !selectedSchuelerId) {
      return () => {
        istAktiv = false;
      };
    }

    fetchGaesteVerzehrFuerSchueler(selectedSchuelerId).catch((error: any) => {
      if (!istAktiv) {
        return;
      }

      console.error('getGaesteVerzehr konnte nicht geladen werden:', error?.message || error);
    });

    return () => {
      istAktiv = false;
    };
  }, [appToken, selectedSchuelerId]);

  const formatLocalDate = (date: Date) => {
    const jahr = date.getFullYear();
    const monat = String(date.getMonth() + 1).padStart(2, '0');
    const tag = String(date.getDate()).padStart(2, '0');
    return `${jahr}-${monat}-${tag}`;
  };

  const getIsoKalenderwoche = (date: Date) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil((((d.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  };

  useEffect(() => {
    const start = new Date(2026, 4, 6);
    const end = new Date(2026, 6, 8);
    const heute = new Date();
    const heuteNurDatum = new Date(heute.getFullYear(), heute.getMonth(), heute.getDate());
    const auswahlJSX: any[] = [];
    const current = new Date(start);
    let letzteKalenderwoche: number | null = null;
    const ausgeschlosseneDaten = new Set([
      // Ferien Hamburg
      '2026-05-11',
      '2026-05-12',
      '2026-05-13',
      '2026-05-14',
      '2026-05-15',
      // Gesetzliche Feiertage Hamburg 2026
      '2026-01-01',
      '2026-04-03',
      '2026-04-06',
      '2026-05-01',
      '2026-05-14',
      '2026-05-25',
      '2026-10-03',
      '2026-10-31',
      '2026-12-25',
      '2026-12-26',
    ]);

    while (current <= end) {
      const tag = current.getDay();
      const datum = formatLocalDate(current);
      const istVergangen = current < heuteNurDatum;

      if (!istVergangen && tag >= 1 && tag <= 5 && !ausgeschlosseneDaten.has(datum)) {
        const kalenderwoche = getIsoKalenderwoche(current);

        if (kalenderwoche !== letzteKalenderwoche) {
          auswahlJSX.push(
            <h1
              key={`kw_${datum}`}
              style={{
                color: 'var(--ion-color-primary)',
                fontFamily: '"Leckerli One", cursive',
                fontWeight: 700,
                background: '#fff',
                display: 'inline-block',
                padding: '4px 10px',
                borderRadius: '8px',
                margin: '16px 12px 8px',
              }}
            >
              KW {kalenderwoche}
            </h1>
          );
          letzteKalenderwoche = kalenderwoche;
        }

        auswahlJSX.push(
          <Auswahl
            key={`auswahl_${datum}`}
            datum={datum}
            dataAuswahl={[]}
            dataVerzehr={{}}
            schuelerPreisProzent={selectedSchuelerPreisProzent}
            schuelerId={selectedSchuelerId}
            vorgemerkteKategorie={neueBestellungen[datum]?.kategorie ?? null}
            vorgemerkteMenge={neueBestellungen[datum]?.menge ?? null}
            serverKategorie={serverKategorieNachDatum[datum] ?? null}
            serverMenge={serverMengeNachDatum[datum] ?? null}
            orderingBlocked={isSchool130}
            orderingBlockedMessage="Bestellungen können erst in der 2. Hälfte der Sommerferien erstellt werden."
            onMenueChange={(payload) => upsertNeueBestellung(datum, payload, serverKategorieNachDatum[datum] ?? null, serverMengeNachDatum[datum] ?? null)}
          />
        );
      }

      current.setDate(current.getDate() + 1);
    }

    setLocalAuswahl(auswahlJSX);
  }, [selectedSchuelerPreisProzent, selectedSchuelerId, neueBestellungen, appWarenkorb, isSchool130]);

  useEffect(() => {
    if (!selectedSchuelerKey || !appWarenkorbResetSignal) {
      return;
    }

    setNeueBestellungenProSchueler((prev) => {
      if (!prev[selectedSchuelerKey]) {
        return prev;
      }

      const next = { ...prev };
      delete next[selectedSchuelerKey];
      return next;
    });
    setIsWarenkorbModalOpen(false);
  }, [appWarenkorbResetSignal, selectedSchuelerKey]);

  useEffect(() => {
    console.log('trigger useeffect warenkorb');

    let WarenkorbJSX = null;

    if (hatWarenkorbEintrag || neueBestellungenListe.length > 0) {
      WarenkorbJSX = (
        <IonFab slot="fixed" vertical="bottom" horizontal="end">
          <IonFabButton color="warning" onClick={() => setIsWarenkorbModalOpen(true)}>
            <IonIcon icon={paperPlaneOutline}></IonIcon>
          </IonFabButton>
        </IonFab>
      );
    }

    setLocalWarenkorbFab(WarenkorbJSX);
  }, [appWarenkorb, hatWarenkorbEintrag, neueBestellungenListe.length]);

  return (
    <IonPage>
      <IonHeader>
        <Toolbar />
       
      </IonHeader>
      <IonContent fullscreen>
 {
                appLoggedIn?
                <IonFab  slot="fixed" vertical="top" horizontal="end" edge={true}>
                          <IonFabButton>
                            <IonIcon icon={cogOutline}></IonIcon>
                          </IonFabButton>
                           <IonFabList side="bottom" style={{ overflow: 'visible' }}>
            <div style={{ position: 'relative', width: '56px', height: '56px',marginBottom:'12px' }}>
              <span
                style={{
                  position: 'absolute',
                  right: '64px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  whiteSpace: 'nowrap',
                  background: '#fff',
                  color: 'var(--ion-color-primary)',
                  fontFamily: '"Leckerli One", cursive',
                  padding: '4px 8px',
                  borderRadius: '10px',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                  pointerEvents: 'none',
                  zIndex: 2,
                }}
              >
                Schüler
              </span>
              <IonFabButton onClick={() => setIsSchuelerkontoModalOpen(true)}>
                <IonIcon icon={peopleCircleOutline} style={{ fontSize: '35px', color: 'var(--ion-color-primary)' }}></IonIcon>
              </IonFabButton>
            </div>

            <div style={{ position: 'relative', width: '56px', height: '56px', marginBottom: '12px' }}>
              <span
                style={{
                  position: 'absolute',
                  right: '64px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  whiteSpace: 'nowrap',
                  background: '#fff',
                  color: 'var(--ion-color-primary)',
                  fontFamily: '"Leckerli One", cursive',
                  padding: '4px 8px',
                  borderRadius: '10px',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                  pointerEvents: 'none',
                  zIndex: 2,
                }}
              >
                Kunde
              </span>
              <IonFabButton onClick={() => setIsKundenkontoModalOpen(true)}>
                <IonIcon icon={personCircleOutline} style={{ fontSize: '35px', color: 'var(--ion-color-primary)' }}></IonIcon>
              </IonFabButton>
            </div>

            <div style={{ position: 'relative', width: '56px', height: '56px' }}>
              <span
                style={{
                  position: 'absolute',
                  right: '64px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  whiteSpace: 'nowrap',
                  background: '#fff',
                  color: 'var(--ion-color-warning)',
                  fontFamily: '"Leckerli One", cursive',
                  padding: '4px 8px',
                  borderRadius: '10px',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
                  pointerEvents: 'none',
                  zIndex: 2,
                }}
              >
                ausloggen
              </span>
              <IonFabButton onClick={() => {appLoggedInChange(false); window.location.reload();}}  >
                <IonIcon icon={logOutOutline} style={{ fontSize: '35px', color: 'var(--ion-color-warning)' }}></IonIcon>
              </IonFabButton>
            </div>
          </IonFabList>
                        </IonFab>
                :null
                }
      
        
        <IonCard >
          
          <IonCardHeader>
            <IonCardTitle>Herzlich Willkommen</IonCardTitle>
            <IonCardSubtitle>
              <div id="schuelerSelect" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '8px' }}>
                {schuelerListe.map((schueler: any, index: number) => {
                  const optionValue = String(schueler.campusmenu_schueler_id || index);
                  const isSelected = String(optionValue) === String(selectedSchuelerId);

                  return (
                    <IonChip
                      key={optionValue}
                      onClick={() => requestSchuelerWechsel(optionValue)}
                      style={{
                        cursor: 'pointer',
                        background: isSelected ? '#ffffff' : '#d3d3d3',
                        color: isSelected ? 'var(--ion-color-primary)' : 'var(--ion-color-dark)',
                        border: isSelected ? '1px solid var(--ion-color-primary)' : '1px solid #b8b8b8',
                      }}
                    >
                      <IonLabel>{getSchuelerLabel(schueler)}</IonLabel>
                    </IonChip>
                  );
                })}
              </div>
              K{formatCampusmenuId(appUserData.campusmenu_id)} - {appUserData.campusmenu_user_login} - {appUserData.campusmenu_user_vorname} {appUserData.campusmenu_user_nachname} 
              
              </IonCardSubtitle>
          </IonCardHeader>
          <IonCardContent>
            {/* <IonButton onClick={()=>appReloadSpeiseplanChange(Math.random())} >neuladen</IonButton> */}
          </IonCardContent>
        </IonCard>
        {selectedSchuelerId ? (
          localAuswahl
        ) : (
          <IonCard>
            <IonCardContent>Bitte wählen Sie oben einen Schüler aus</IonCardContent>
          </IonCard>
        )}

        {selectedSchuelerId ? (
          <IonFab slot="fixed" vertical="bottom" horizontal="start">
            <IonFabButton onClick={() => setIsKontoModalOpen(true)}>
              <IonIcon icon={cashOutline}></IonIcon>
            </IonFabButton>
          </IonFab>
        ) : null}

        {localWarenkorbFab}

       

        <IonModal isOpen={isKundenkontoModalOpen} onDidDismiss={() => setIsKundenkontoModalOpen(false)}>
          <Settings
            section="kundenkonto"
            embedded={true}
            onClose={() => setIsKundenkontoModalOpen(false)}
            selectedSchuelerId={selectedSchuelerId}
            onSelectedSchuelerIdChange={requestSchuelerWechsel}
          />
        </IonModal>

        <IonModal isOpen={isSchuelerkontoModalOpen} onDidDismiss={() => setIsSchuelerkontoModalOpen(false)}>
          <Settings
            section="schuelerkonto"
            embedded={true}
            onClose={() => setIsSchuelerkontoModalOpen(false)}
            selectedSchuelerId={selectedSchuelerId}
            onSelectedSchuelerIdChange={requestSchuelerWechsel}
          />
        </IonModal>

        <IonModal isOpen={isHinweisModalOpen} onDidDismiss={abbrechenSchuelerWechsel}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Hinweis</IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonCard>
              <IonCardHeader>
                <IonCardTitle>Ungesendete Auswahl vorhanden</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                Wenn Sie den Schüler wechseln, geht die aktuelle Auswahl im Warenkorb verloren, sofern die Bestellung nicht zuvor abgesendet wird.
                <div style={{ display: 'flex', gap: '8px', marginTop: '16px', justifyContent: 'flex-end' }}>
                  <IonButton fill="outline" onClick={abbrechenSchuelerWechsel}>Abbrechen</IonButton>
                  <IonButton color="warning" onClick={bestaetigeSchuelerWechsel}>Trotzdem wechseln</IonButton>
                </div>
              </IonCardContent>
            </IonCard>
          </IonContent>
        </IonModal>

        <IonModal isOpen={isKontoModalOpen} onDidDismiss={() => setIsKontoModalOpen(false)}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Kontostand</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setIsKontoModalOpen(false)}>Schließen</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonCard>
              <IonCardHeader>
                <IonCardTitle>{getSchuelerLabel(selectedSchueler)}</IonCardTitle>
              </IonCardHeader>
              <IonCardContent>
                <IonItem lines="none" style={{ marginBottom: '8px' }}>
                  <IonLabel>
                    <h3><b>Startkontostand</b></h3>
                  </IonLabel>
                  <IonLabel slot="end"><b>{waehrungFormatter.format(0)}</b></IonLabel>
                </IonItem>
                {kontoZeilenGesamt.length === 0 ? (
                  <IonItem lines="none">
                    <IonLabel>Keine Bewegungen vorhanden.</IonLabel>
                  </IonItem>
                ) : (
                  <>
                    {kontoZeilenBisZwischenstand.map((zeile: any) =>
                      zeile.type === 'sonderbuchung' ? (
                        <IonItem key={`lastschrift_${zeile.id}`} lines="inset">
                          <IonLabel>
                            <h3>{getSonderbuchungTitel(String(zeile.kategorie || ''))}</h3>
                            <p>{zeile.datumAnzeige}</p>
                            {zeile.wertstellung && <p>Wertstellung: {zeile.wertstellung}</p>}
                            {zeile.anmerkung && <p>{zeile.anmerkung}</p>}
                          </IonLabel>
                          <IonLabel slot="end"><b>{waehrungFormatter.format(zeile.gesamtpreis)}</b></IonLabel>
                        </IonItem>
                      ) : (
                        <IonAccordionGroup key={`konto_tag_${zeile.datum}`}>
                          <IonAccordion value={`bewegung_${zeile.datum}`}>
                            <IonItem slot="header">
                              <IonLabel>
                                <h3>{zeile.datumAnzeige}</h3>
                                <p>
                                  {(() => {
                                    const menueBewegungen = (zeile.bewegungen || []).filter((bewegung: any) => menuKategorien.has(String(bewegung.kategorie || '')));

                                    if (menueBewegungen.length === 1) {
                                      const bewegung = menueBewegungen[0];
                                      const menueTitel = getMenueTitel(String(bewegung.kategorie || ''));

                                      if (menueTitel) {
                                        return `${formatMengeMalWert(bewegung.menge, bewegung.einzelpreis)} ${menueTitel}`;
                                      }
                                    }

                                    const ersteBewegung = (zeile.bewegungen || [])[0];
                                    return formatMengeMalWert(zeile.gesamtMenge, ersteBewegung?.einzelpreis ?? 0);
                                  })()}
                                </p>
                              </IonLabel>
                              <IonLabel slot="end">{waehrungFormatter.format(Number(zeile.gesamtPreis || 0))}</IonLabel>
                            </IonItem>
                            <div className="ion-padding" slot="content">
                              <IonList>
                                {zeile.bewegungen.map((bewegung: any) => (
                                  <IonItem key={`konto_${bewegung.id}`}>
                                    <IonLabel>
                                      <h3>{bewegung.text}</h3>
                                      <p>Wertstellung: {bewegung.wertstellung || '-'}</p>
                                      <p>Anmerkung: {bewegung.anmerkung || '-'}</p>
                                    </IonLabel>
                                    <IonLabel slot="end">
                                      {formatMengeMalWert(bewegung.menge, bewegung.einzelpreis)}
                                    </IonLabel>
                                  </IonItem>
                                ))}
                              </IonList>
                            </div>
                          </IonAccordion>
                        </IonAccordionGroup>
                      )
                    )}
                    <IonItem lines="none" style={{ marginTop: '8px', marginBottom: '8px' }}>
                      <IonLabel>
                        <h3><b>Zwischenkontostand bis {zwischenstandStichtagAnzeige}</b></h3>
                      </IonLabel>
                      <IonLabel slot="end"><b>{waehrungFormatter.format(kontoZwischenstand30Tage)}</b></IonLabel>
                    </IonItem>
                    <IonAccordionGroup>
                      <IonAccordion value="weitere_bestellungen">
                        <IonItem slot="header">
                          <IonLabel>
                            <h3>weitere Bestellungen</h3>
                            <p>{kontoZeilenNachZwischenstand.length} Einträge</p>
                          </IonLabel>
                        </IonItem>
                        <div className="ion-padding" slot="content">
                          {kontoZeilenNachZwischenstand.length === 0 ? (
                            <IonItem lines="none">
                              <IonLabel>Keine weiteren Bestellungen vorhanden.</IonLabel>
                            </IonItem>
                          ) : (
                            <IonList>
                              {kontoZeilenNachZwischenstand.map((zeile: any) =>
                                zeile.type === 'sonderbuchung' ? (
                                  <IonItem key={`weitere_lastschrift_${zeile.id}`}>
                                    <IonLabel>
                                      <h3>{getSonderbuchungTitel(String(zeile.kategorie || ''))}</h3>
                                      <p>{zeile.datumAnzeige}</p>
                                      {zeile.wertstellung && <p>Wertstellung: {zeile.wertstellung}</p>}
                                      {zeile.anmerkung && <p>{zeile.anmerkung}</p>}
                                    </IonLabel>
                                    <IonLabel slot="end">{waehrungFormatter.format(zeile.gesamtpreis)}</IonLabel>
                                  </IonItem>
                                ) : (
                                  <React.Fragment key={`weitere_${zeile.datum}`}>
                                    <IonItem>
                                      <IonLabel>
                                        <h3>{zeile.datumAnzeige}</h3>
                                        <p>{formatMengeMalWert(zeile.gesamtMenge, (zeile.bewegungen || [])[0]?.einzelpreis ?? 0)}</p>
                                      </IonLabel>
                                    </IonItem>
                                    {zeile.bewegungen.map((bewegung: any) => (
                                      <IonItem key={`weitere_bewegung_${bewegung.id}`}>
                                        <IonLabel>
                                          <p>{bewegung.text}</p>
                                          <p>Wertstellung: {bewegung.wertstellung || '-'}</p>
                                          <p>Anmerkung: {bewegung.anmerkung || '-'}</p>
                                        </IonLabel>
                                        <IonLabel slot="end">
                                          {formatMengeMalWert(bewegung.menge, bewegung.einzelpreis)}
                                        </IonLabel>
                                      </IonItem>
                                    ))}
                                  </React.Fragment>
                                )
                              )}
                            </IonList>
                          )}
                          <IonItem lines="none" style={{ marginTop: '12px' }}>
                            <IonLabel>
                              <h3>Kontostand</h3>
                            </IonLabel>
                            <IonLabel slot="end"><b>{waehrungFormatter.format(kontoEndsaldo)}</b></IonLabel>
                          </IonItem>
                        </div>
                      </IonAccordion>
                    </IonAccordionGroup>
                  </>
                )}
              </IonCardContent>
            </IonCard>
          </IonContent>
        </IonModal>

        <IonModal isOpen={isWarenkorbModalOpen} onDidDismiss={() => setIsWarenkorbModalOpen(false)}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Warenkorb</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setIsWarenkorbModalOpen(false)}>Schließen</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            {neueBestellungenListe.length > 0 ? (
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>Neue Bestellungen</IonCardTitle>
                  <IonCardSubtitle>
                    {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(neueBestellungenSumme)}
                  </IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>
                  <IonList>
                    {neueBestellungenListe.map((eintrag: any, index: number) => (
                      <IonItem key={`neu_${eintrag.datum}_${eintrag.kategorie}_${eintrag.menge}_${index}`}>
                        <IonLabel>
                          {new Date(`${eintrag.datum}T00:00:00`).toLocaleDateString('de-DE', { dateStyle: 'medium' })}: {Number(eintrag.menge ?? 1) < 0 ? 'Storno ' : ''}Menü {eintrag.kategorie} - {eintrag.titel}
                        </IonLabel>
                        <IonLabel slot="end">
                          {(Number(eintrag.menge ?? 1) < 0 ? '-' : '')}{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(Number(eintrag.preis || 0))}
                        </IonLabel>
                      </IonItem>
                    ))}
                  </IonList>
                  {String(selectedSchueler?.campusmenu_schueler_zahlung) === '1' && neueBestellungenSumme > 0 && (
                    <IonItem lines="none">
                      <IonCheckbox
                        checked={lastschriftEinzug}
                        onIonChange={(e) => setLastschriftEinzug(e.detail.checked)}
                        slot="start"
                      />
                      <IonLabel>Lastschrifteinzug anstossen</IonLabel>
                    </IonItem>
                  )}
                  <IonButton expand="block" color="warning" onClick={zahlungspflichtigBestellen} disabled={isBestellenLoading}>
                    {isBestellenLoading ? 'Übertrage...' : 'zahlungspflichtig bestellen'}
                  </IonButton>
                </IonCardContent>
              </IonCard>
            ) : (
              <IonCard>
                <IonCardContent>Keine neuen Bestellungen vorgemerkt.</IonCardContent>
              </IonCard>
            )}
          </IonContent>
        </IonModal>

        
        
      </IonContent>
    </IonPage>
  );
};

export default Home;
